export default __webpack_public_path__ + "files/media/plane.react.b8323749.svg";